import { render } from "./wcPage.vue?vue&type=template&id=26ba7d8c&scoped=true"
import script from "./wcPage.vue?vue&type=script&lang=js"
export * from "./wcPage.vue?vue&type=script&lang=js"

import "./wcPage.vue?vue&type=style&index=0&id=26ba7d8c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ba7d8c"]])

export default __exports__